module.exports = __webpack_public_path__ + "img/ava-hub.3003edee.svg";